import { useRef, useLayoutEffect } from 'react'
import Styles from './useFadingScrollbar.module.scss'
import useResponsiveDesign from './useResponsiveDesign'

export const useFadingScrollbar = (element?: HTMLElement | null) => {
  const timer = useRef<ReturnType<typeof setTimeout>>()
  const { isMobile } = useResponsiveDesign()

  const handleScroll = () => {
    if (!element) {
      return
    }
    element.classList.add(Styles.scrolling)
    if (timer.current) {
      clearTimeout(timer.current)
    }
    timer.current = setTimeout(() => {
      element.classList.remove(Styles.scrolling)
    }, 1000)
  }

  useLayoutEffect(() => {
    if (!element || isMobile) {
      return
    }
    element.classList.add(Styles.container)
    element.addEventListener('scroll', handleScroll, true)

    return () => {
      element.removeEventListener('scroll', handleScroll, true)
      element.classList.remove(Styles.container)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })
}
